import {FETCH_POST_PARAMS, smartFetch} from "../utils";
export const FIELD_UPDATED = 'FIELD_UPDATED';
export const fieldUpdated = (field, value) => ({type: FIELD_UPDATED, field, value});

export const FORM_PROCESSING = 'FORM_PROCESSING';
export const formProcessing = processing => ({type: FORM_PROCESSING, processing});

export const SUBSCRIBED_UPDATED = 'SUBSCRIBED_UPDATED';
export const subscribedUpdated = subscribed => ({type: SUBSCRIBED_UPDATED, subscribed});

export function subscribe(data) {
    return dispatch => {
        dispatch(formProcessing(true));
        data['delivery'] = deliveryMachineName;
        return smartFetch('/delivery/api/deliveries/subscribe.json', FETCH_POST_PARAMS(data))
            .then(response => response.json())
            .then(json => {
                if (json.account_created) {
                    location.reload();
                }
                dispatch(formProcessing(false));
                dispatch(subscribedUpdated(json));
            })
            .catch(e => {
                console.error(e);
                dispatch(formProcessing(false));
            });
    }
}


// WEBPACK FOOTER //
// ./src/delivery/actions.js